export const RelationshipEditType = {
    REMOVE: 'RELATIONSHIP_REMOVE',
    ADD: 'RELATIONSHIP_ADD',
    NOOP: 'RELATIONSHIP_NOOP'
};
export var InputVariant = /*#__PURE__*/ function(InputVariant) {
    InputVariant["TEXT"] = "text";
    InputVariant["SEARCH"] = "search";
    return InputVariant;
}({});
export var InputSize = /*#__PURE__*/ function(InputSize) {
    InputSize["XS"] = "xs";
    InputSize["SM"] = "sm";
    InputSize["MD"] = "md";
    InputSize["LG"] = "lg";
    return InputSize;
}({});
export var ButtonVariant = /*#__PURE__*/ function(ButtonVariant) {
    ButtonVariant["PRIMARY"] = "primary";
    ButtonVariant["SECONDARY"] = "secondary";
    ButtonVariant["LINKS"] = "links";
    return ButtonVariant;
}({});
export var TextareaVariant = /*#__PURE__*/ function(TextareaVariant) {
    TextareaVariant["OUTLINE"] = "outline";
    TextareaVariant["FLUSHED"] = "flushed";
    TextareaVariant["FILLED"] = "filled";
    TextareaVariant["UNSTYLED"] = "unstyled";
    return TextareaVariant;
}({});
export var TextareaSize = /*#__PURE__*/ function(TextareaSize) {
    TextareaSize["XS"] = "xs";
    TextareaSize["SM"] = "sm";
    TextareaSize["MD"] = "md";
    TextareaSize["LG"] = "lg";
    return TextareaSize;
}({});
export var ButtonSize = /*#__PURE__*/ function(ButtonSize) {
    ButtonSize["XS"] = "xs";
    ButtonSize["SM"] = "sm";
    ButtonSize["MD"] = "md";
    ButtonSize["LG"] = "lg";
    return ButtonSize;
}({});
export var ToastVariants = /*#__PURE__*/ function(ToastVariants) {
    ToastVariants["SUCCESS"] = "SUCCESS";
    ToastVariants["INFO"] = "INFO";
    ToastVariants["WARNING"] = "WARNING";
    ToastVariants["ERROR"] = "ERROR";
    return ToastVariants;
}({});
export var ToastPositions = /*#__PURE__*/ function(ToastPositions) {
    ToastPositions["TOP"] = "top";
    ToastPositions["BOTTOM"] = "bottom";
    ToastPositions["TOP_LEFT"] = "top-left";
    ToastPositions["TOP_RIGHT"] = "top-right";
    ToastPositions["BOTTOM_LEFT"] = "bottom-left";
    ToastPositions["BOTTOM_RIGHT"] = "bottom-right";
    return ToastPositions;
}({});
